<template>
  <footer
    class="bg-gradient-to-b from-color-background to-color-background-2 border-t border-border mt-6 sm:mt-20"
  >
    <div class="container-custom py-4 sm:py-2 md:py-16">
      <div class="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-5 sm:gap-6 mb-6 sm:mb-12">
        <!-- آیتم اول -->
        <div class="flex flex-col sm:flex-row items-center text-center sm:text-right p-3 sm:p-4 rounded-lg hover:bg-[var(--color-background-2)] transition-colors gap-2 sm:gap-4">
          <div class="w-10 h-10 sm:w-12 sm:h-12 flex-shrink-0 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1037.62 1037.62" class="w-full h-full">
              <circle fill="var(--color-border)" cx="518.81" cy="518.81" r="518.81" />
              <g fill="var(--color-primary)">
                <path d="M507.43,451.19l-68.4-61.9c-7.03-6.36-17.89-5.83-24.26,1.21-6.36,7.03-5.83,17.89,1.21,24.26l79.6,72.05c3.27,2.96,7.39,4.44,11.53,4.44s7.95-1.37,11.17-4.13l165.98-142.13c2.97,12.61,4.56,25.74,4.56,39.25,0,47.12-19.15,89.86-50.07,120.84h44.99c24.76-33.94,39.43-75.7,39.43-120.84,0-35.35-8.98-68.64-24.76-97.72l-25.28,22.78-165.71,141.89Z"/>
                <path d="M899.56,672.01l-147.22-140.12c-3.19-3.04-7.43-4.73-11.84-4.73h-453.12c-4.41,0-8.65,1.7-11.84,4.73l-147.22,140.12c-5.09,4.84-6.71,12.3-4.11,18.82,2.61,6.52,8.92,10.8,15.95,10.8h130.32v122.94c0,9.48,7.69,17.18,17.18,17.18h441.66c9.48,0,17.18-7.69,17.18-17.18v-122.94h141.22c7.03,0,13.34-4.28,15.95-10.8,2.61-6.52.98-13.98-4.11-18.82ZM712.14,807.4h-115.32v-139.65l25.19,28.28c3.25,3.57,7.86,5.61,12.7,5.61h77.43v105.77ZM642.3,667.28l-33.43-38.16h-22.53c-2.06-.87-4.32-1.36-6.7-1.36s-4.64.48-6.69,1.36h-10.54l4.22,4.73c-2.56,3-4.16,6.84-4.16,11.09v162.46h-257.63v-105.77h152.13c4.84,0,9.45-2.04,12.7-5.61l64.43-68.26h-46.46l-38.26,39.52H183.11l111.13-105.77h439.38l111.13,105.77h-202.46Z"/>
                <path d="M396.61,505.08c-30.92-30.98-50.07-73.71-50.07-120.84,0-94.37,76.78-171.15,171.15-171.15,46.61,0,88.91,18.75,119.81,49.09l25.57-23.04c-37.22-37.29-88.65-60.4-145.38-60.4-113.31,0-205.5,92.18-205.5,205.5,0,45.14,14.66,86.9,39.43,120.84h44.99Z"/>
              </g>
            </svg>
          </div>
          <div class="flex flex-col">
            <h4 class="text-xs sm:text-xs font-semibold text-[var(--color-text-primary)] mb-1">اصالت کالا ها</h4>
            <p class="hidden sm:block text-xs text-[var(--color-text-secondary)]">از برترین برندها</p>
          </div>
        </div>

        <!-- آیتم دوم (بازگشت وجه) - در موبایل مخفی -->
        <div class="hidden sm:flex flex-col sm:flex-row items-center text-center sm:text-right p-3 sm:p-4 rounded-lg hover:bg-[var(--color-background-2)] transition-colors gap-2 sm:gap-4">
          <div class="w-10 h-10 sm:w-12 sm:h-12 flex-shrink-0 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1037.62 1037.62" class="w-full h-full">
              <circle fill="var(--color-border)" cx="518.81" cy="518.81" r="518.81" />
              <g fill="var(--color-primary)">
                <path d="M519.93,183.77c-190.87,0-346.15,155.28-346.15,346.15s155.28,346.15,346.15,346.15,346.15-155.28,346.15-346.15-155.28-346.15-346.15-346.15ZM519.93,837.61c-169.66,0-307.69-138.03-307.69-307.69s138.03-307.69,307.69-307.69,307.69,138.03,307.69,307.69-138.03,307.69-307.69,307.69Z"/>
                <path d="M322.82,524.64c0-49.83,17.69-95.6,47.1-131.38-10.32-8.06-21.18-15.03-32.49-20.86-33.19,41.89-53.07,94.77-53.07,152.24,0,111.63,74.87,206.05,177.01,235.83,3.91-11.99,7.19-24.42,9.87-37.17-85.7-25.41-148.42-104.83-148.42-198.66Z"/>
                <path d="M702.46,633.36l-177.71-100.25v-209.92c0-10.62-8.61-19.23-19.23-19.23s-19.23,8.61-19.23,19.23v221.15c0,.25.06.48.07.72.03.69.11,1.36.2,2.04.09.6.18,1.19.32,1.77.15.6.34,1.18.55,1.76.21.6.41,1.19.68,1.75.26.56.57,1.08.88,1.61.31.53.61,1.06.97,1.55.37.51.78.98,1.2,1.46.41.46.81.92,1.26,1.33.44.41.92.78,1.4,1.16.53.41,1.07.81,1.65,1.16.21.13.38.3.61.43l187.5,105.77c2.99,1.68,6.23,2.48,9.43,2.48,6.71,0,13.24-3.52,16.77-9.79,5.21-9.25,1.95-20.98-7.31-26.2Z"/>
              </g>
            </svg>
          </div>
          <div class="flex flex-col">
            <h4 class="text-xs sm:text-xs font-semibold text-[var(--color-text-primary)] mb-1">بازگشت وجه</h4>
            <p class="hidden sm:block text-xs text-[var(--color-text-secondary)]">در صورت عدم رضایت</p>
          </div>
        </div>

        <!-- آیتم سوم -->
        <div class="flex flex-col sm:flex-row items-center text-center sm:text-right p-3 sm:p-4 rounded-lg hover:bg-[var(--color-background-2)] transition-colors gap-2 sm:gap-4">
          <div class="w-10 h-10 sm:w-12 sm:h-12 flex-shrink-0 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1037.62 1037.62" class="w-full h-full">
              <circle fill="var(--color-border)" cx="518.81" cy="518.81" r="518.81" />
              <g fill="var(--color-primary)">
                <path d="M910.22,393.52l-73.16-86.31c-24.56-28.96-68.12-32.55-96.97-8.11l-36.02,28.04-.4-.13c-25.38-8.08-111.62-33.94-155.8-27.98-6.74.93-14.52,2.84-23.12,5.69l-.24.08-.25-.08c-65.43-20.53-96.62-8.03-121.65,2.01l-1.11.44c-11.9,4.78-22.24,8.94-35.87,8.68l-17.47-.14c-39.93-.28-50.66-.35-58.26-5.88-36.54-26.64-67.8-25.34-95.56,3.96l-59.91,81.62c-29.67,32.26-8.51,77.45,1.97,95.37l30.37,52.88,1.71,1.84c5.91,5.58,12.75,10.04,20.33,13.24l1.1.47-25.6,25.2c-16.8,16.54-17.01,43.66-.47,60.47l14.84,15.06c4.51,4.57,9.89,8,16.01,10.18l.68.24-.17.7c-3.51,14.53.6,29.52,11.01,40.11l14.84,15.06c7.99,8.12,18.69,12.64,30.17,12.73,5.74,0,11.02-.99,16.12-3.01l.75-.3.29.75c2.11,5.46,5.27,10.35,9.37,14.53l14.83,15.07c8.09,8.21,18.91,12.73,30.47,12.73,6.41,0,12.89-1.5,18.72-4.34l.76-.37.33.77c2.12,5.03,5.11,9.52,8.88,13.34l14.83,15.06c8.09,8.21,18.91,12.74,30.47,12.74s21.96-4.36,30-12.27l10.16-10.01,20.54,17.27c6.57,6.14,14.2,10.47,22.69,12.86l.55.22c7.8,4.06,16.54,6.2,25.27,6.2,15.12,0,29.71-6.31,40.02-17.32,4.64-4.96,8.29-10.81,10.86-17.39l.43-1.1,6.42,6.01c6.45,6.04,14.02,10.31,22.51,12.7l.56.22c7.8,4.06,16.53,6.2,25.27,6.2,15.12,0,29.71-6.32,40.01-17.32,6.6-7.04,11.21-15.78,13.34-25.28l.2-.91.86.34c6.44,2.54,13.21,3.83,20.11,3.83,15.12,0,29.71-6.31,40.02-17.33,9.97-10.66,15.19-24.59,14.7-39.24-.07-2.1-.3-4.32-.72-6.98l-.17-1.05,1.05.13c3.29.44,6.06.59,8.93.47,14.65-.48,28.21-6.61,38.18-17.26,9.99-10.67,15.22-24.61,14.73-39.25-.48-14.64-6.62-28.2-17.29-38.18l-12.54-11.74,1.29-.41c8.75-2.78,16.69-7.16,23.84-13.24l101.14-101.75c13.57-11.8,22.66-29.3,24.94-47.99,2.4-19.76-2.95-39.03-14.68-52.87ZM215.07,642.42l-.13.06c-1.89.87-3.85,1.31-5.71,1.31h-.44c-3.63-.09-7.02-1.54-9.55-4.1l-14.84-15.07c-5.36-5.44-5.3-14.24.15-19.6l78.84-77.63c2.58-2.54,6.03-3.94,9.68-3.94,3.87.03,7.3,1.45,9.91,4.11l14.83,15.05c4.08,4.15,5.1,10.48,2.56,15.75l-85.32,84.07ZM261.2,706.13h0c-2.55,2.52-5.94,3.96-9.3,3.96l-.71-.02c-3.61-.03-7.01-1.48-9.59-4.1l-14.83-15.06c-5.36-5.45-5.29-14.24.12-19.58l6.14-5.93c2.16-1.46,4.21-3.13,6.08-4.98l78.84-77.63c1.88-1.84,3.63-3.94,4.98-5.93l7.72-7.69c2.59-2.55,6.04-3.95,9.68-3.95,3.87.03,7.3,1.45,9.91,4.1l14.83,15.05c2.58,2.63,3.98,6.13,3.95,9.85-.03,3.72-1.48,7.18-4.1,9.76l-103.72,102.13ZM332.74,745.88c-5.28,5.18-14.42,5.11-19.6-.15l-14.83-15.07c-5.36-5.45-5.29-14.24.15-19.6l71.73-70.62c2.6-2.56,6.05-3.98,9.81-3.98h.01c3.71.03,7.18,1.5,9.77,4.13l14.83,15.06c5.36,5.45,5.29,14.25-.15,19.61l-71.73,70.62ZM441.9,748.45l-35.18,34.64c-2.55,2.51-5.92,3.92-9.5,3.98h-.34c-3.7-.03-7.17-1.5-9.76-4.13l-14.83-15.07c-2.59-2.63-4.01-6.12-3.98-9.82.03-3.71,1.5-7.18,4.13-9.77l35.17-34.64c2.53-2.49,6.02-3.89,9.73-3.95,3.79.03,7.3,1.48,9.88,4.1l14.83,15.06c5.36,5.45,5.29,14.24-.15,19.61ZM759.95,677.83c-5.48,5.86-12.97,9.23-21.12,9.5-2.03.07-4.16-.06-6.33-.44l-.3-.12c-1.49-.98-2.87-2.05-4.06-3.16-53.36-50.45-86.34-82.06-98.03-93.95l-3.41-3.21-.61.84-.64-.39c-2.69-1.64-5.75-2.5-8.83-2.5-9.24,0-16.77,7.31-16.77,16.29,0,.49.18.94.23,1.43l4.1,9.66,1.46,2.01,90.93,85.21c5.87,5.49,9.24,12.98,9.51,21.08.27,8.1-2.6,15.8-8.09,21.66-7,7.48-17.28,10.86-27.45,9.07l-.29-.11c-1.57-1.03-2.91-2.08-4.09-3.19l-2.96-2.77-.07-.17c-3.01-7.62-7.52-14.27-13.52-19.89l-82.44-71.49-2.88-1.49c-2.3-1.05-4.69-1.58-7.11-1.58-9.24,0-16.76,7.31-16.76,16.29,0,4.99,2.37,9.65,6.5,12.8l.55.42-.06.09,83.43,74.21.05.26c.37,1.81.59,3.58.65,5.25.27,8.11-2.61,15.8-8.09,21.66-7.01,7.49-17.29,10.85-27.45,9.07l-.29-.12c-1.54-1.01-2.88-2.05-4.08-3.17l-34.67-32.43-1.36-1.49c-15.68-17.22-25.48-27.73-29.2-31.31l-.51-.44c-3.25-3.56-7.69-5.52-12.49-5.52-9.24,0-16.76,7.31-16.76,16.29,0,6.44,3.93,12.28,9.97,14.87l17.97,16.75.06.24c2.47,10.01-.23,20.46-7.23,27.95-6.91,7.38-17.26,10.87-27.45,9.07l-.16-.03-.14-.09c-1.55-1.02-2.88-2.05-4.24-3.31l-28.02-23.67,4.77-4.69c16.8-16.54,17.01-43.67.47-60.48l-14.83-15.06c-3.97-4.04-8.61-7.2-13.78-9.38l-.75-.32.34-.74c7.27-16.03,3.89-35.2-8.41-47.69l-14.83-15.07c-4.22-4.28-9.23-7.57-14.88-9.77l-.74-.29.28-.74c1.87-4.87,2.83-9.93,2.87-15.05.09-11.44-4.26-22.21-12.25-30.34l-14.83-15.06c-7.99-8.12-18.69-12.64-30.17-12.73-4.07,0-7.91.51-11.73,1.56l-.7.19-.25-.68c-2.12-5.72-5.34-10.79-9.56-15.08l-14.84-15.07c-8-8.11-18.7-12.63-30.17-12.72-11.51,0-22.27,4.35-30.29,12.25l-24.35,23.98-.44.04c-.77.09-1.16.14-1.54.15-8.83.27-17.42-2.71-24.08-8.35l-32.04-54.5c-10.26-21.41-15.49-35.48-1.68-50.28l59.88-81.59c14.11-14.78,25.47-18.44,51.43.47,16.44,11.98,37.31,12.09,78.87,12.3h1.07c4.76.03,9.78.06,15.14.11,21.14-.11,36.24-6.16,49.69-11.55,15.52-6.23,31.57-12.67,57.75-10.16l2.4.23-2.07,1.24c-32.46,19.48-56.38,42.12-67.36,63.76-12.28,24.22-7.32,43.24-.99,54.93,22.18,40.93,68.11,22.12,101.65,8.38,26.72-10.94,47.78-18.68,55.56-10.77,32.36,32.91,155.59,156.99,167.4,162.87l29.11,27.04c5.89,5.52,9.28,13,9.55,21.08.27,8.09-2.62,15.78-8.13,21.67ZM891.89,442.36c-1.32,10.81-6.34,20.63-14.03,27.16l-101.47,102.04c-6.26,5.05-14.19,7.83-22.35,7.83-6.26,0-12.39-1.63-17.77-4.71l-18.47-17.18-3.75-3.86c-66.1-68.07-109.28-112.41-128.32-131.78-8.72-8.86-19.46-13.17-32.83-13.17-18.8,0-39.25,8.37-59.02,16.46-44.67,18.29-54.23,16.91-59.82,6.56-3.81-7.02-3.36-14.66,1.4-24.04,17.97-35.44,83.58-71.15,116.88-75.69,36.11-4.91,120.61,19.71,150.11,29.61l8.91,3,50.21-40.1c7.13-6.06,16.33-8.98,25.86-8.23,9.5.78,18.11,5.21,24.26,12.45l73.17,86.31c5.77,6.79,8.32,16.76,7.03,27.34Z"/>
              </g>
            </svg>
          </div>
          <div class="flex flex-col">
            <h4 class="text-xs sm:text-xs font-semibold text-[var(--color-text-primary)] mb-1">پشتیبانی عالی</h4>
            <p class="hidden sm:block text-xs text-[var(--color-text-secondary)]">24 ساعته، 7 روز هفته</p>
          </div>
        </div>

        <!-- آیتم چهارم -->
        <div class="flex flex-col sm:flex-row items-center text-center sm:text-right p-3 sm:p-4 rounded-lg hover:bg-[var(--color-background-2)] transition-colors gap-2 sm:gap-4">
          <div class="w-10 h-10 sm:w-12 sm:h-12 flex-shrink-0 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1037.62 1037.62" class="w-full h-full">
              <circle fill="var(--color-border)" cx="518.81" cy="518.81" r="518.81" />
              <g fill="var(--color-primary)">
                <path d="M892.91,520.03h-22.03l-52.24-98.98c-3.24-6.1-9.54-9.91-16.46-9.94l-132.64-.23v-135.91H194.51v94.77h37.31v-57.45h400.4v368.53h-189.62l-.31-.69c-13.68-30.82-44.2-50.73-77.74-50.73s-63.75,19.91-77.7,50.74l-.31.68h-54.72v-61.6h-37.31v98.93h85.02l.06,1.1c2.49,45.06,39.81,80.35,84.97,80.35s82.47-35.29,84.96-80.35l.06-1.1h247.95l.06,1.1c2.49,45.06,39.81,80.35,84.96,80.35s82.48-35.29,84.97-80.35l.06-1.1h25.32c25.3,0,45.88-20.59,45.88-45.89v-106.34c0-25.3-20.58-45.89-45.88-45.89ZM364.56,762.27c-26.35,0-47.78-21.43-47.78-47.78s21.44-47.78,47.78-47.78,47.78,21.43,47.78,47.78-21.44,47.78-47.78,47.78ZM758.92,448.36l31.98.05,28.96,54.86,9.35,18.84h-70.29v-73.75ZM782.56,762.27c-26.35,0-47.78-21.43-47.78-47.78s21.44-47.78,47.78-47.78,47.78,21.43,47.78,47.78-21.44,47.78-47.78,47.78ZM901.48,672.26c0,4.72-3.84,8.56-8.57,8.56h-32.29l-.31-.69c-13.68-30.82-44.2-50.73-77.75-50.73s-63.76,19.91-77.7,50.74l-.31.68h-35v-232.62l54.36.09v91.33c0,9.66,7.85,17.51,17.5,17.51l116.26-.03c.52.03.8.07,1.07.13.3.05.59.12.89.12h33.27c4.73,0,8.57,3.84,8.57,8.57v106.34Z"/>
                <path d="M488.28,421.46c0-9.65-7.85-17.5-17.5-17.5H106.58c-9.65,0-17.5,7.85-17.5,17.5s7.85,17.51,17.5,17.51h364.2c9.65,0,17.5-7.85,17.5-17.51Z"/>
                <path d="M488.28,491.39c0-9.65-7.85-17.5-17.5-17.5H185.76c-9.65,0-17.5,7.85-17.5,17.5s7.85,17.51,17.5,17.51h285.02c9.65,0,17.5-7.85,17.5-17.51Z"/>
              </g>
            </svg>
          </div>
          <div class="flex flex-col">
            <h4 class="text-xs sm:text-xs font-semibold text-[var(--color-text-primary)] mb-1">تحویل سریع</h4>
            <p class="hidden sm:block text-xs text-[var(--color-text-secondary)]">در کمترین زمان ممکن</p>
          </div>
        </div>

        <!-- آیتم پنجم -->
        <div class="flex flex-col sm:flex-row items-center text-center sm:text-right p-3 sm:p-4 rounded-lg hover:bg-[var(--color-background-2)] transition-colors gap-2 sm:gap-4">
          <div class="w-10 h-10 sm:w-12 sm:h-12 flex-shrink-0 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1037.62 1037.62" class="w-full h-full">
              <circle fill="var(--color-border)" cx="518.81" cy="518.81" r="518.81" />
              <g fill="var(--color-primary)">
                <path d="M672.97,449.26H205.34c-30.51,0-55.33,23.89-55.33,53.24v259.3c0,29.36,24.83,53.24,55.33,53.24h467.64c30.51,0,55.33-23.89,55.33-53.24v-259.3c0-29.36-24.83-53.24-55.33-53.24ZM689.77,761.8c0,8.92-7.53,16.16-16.8,16.16H205.34c-9.27,0-16.8-7.25-16.8-16.16v-259.3c0-8.92,7.53-16.16,16.8-16.16h467.64c9.27,0,16.8,7.25,16.8,16.16v259.3Z"/>
                <path d="M632.78,689.15H231.43c-10.64,0-19.27,8.3-19.27,18.54s8.63,18.54,19.27,18.54h401.35c10.64,0,19.27-8.3,19.27-18.54s-8.63-18.54-19.27-18.54Z"/>
                <path d="M886.03,348.39l-453.25-124.85c-18.11-5-37.11,5.13-42.3,22.59l-16.21,54.47v.02s-.01.03-.01.03l-34.46,115.8h38.82l26.39-88.68,447.27,123.21-60.31,202.68-37.72-10.39v37.36l30.45,8.39c3.14.86,6.29,1.27,9.4,1.27,14.88,0,28.6-9.42,32.9-23.86l66.3-222.81h0s0-.02,0-.02l16.21-54.48c5.19-17.45-5.34-35.71-23.48-40.71ZM862.55,416.45l-447.27-123.21,10.22-34.34,447.27,123.2-10.22,34.35Z"/>
              </g>
            </svg>
          </div>
          <div class="flex flex-col">
            <h4 class="text-xs sm:text-xs font-semibold text-[var(--color-text-primary)] mb-1">تضمین قیمت</h4>
            <p class="hidden sm:block text-xs text-[var(--color-text-secondary)]">بهترین قیمت بازار</p>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-5 gap-4 sm:gap-8">
        <div class="md:col-span-2">
          <div class="flex items-center gap-2 sm:gap-3 mb-2 sm:mb-4">
            <div class="relative w-8 h-8 sm:w-12 sm:h-12 shrink-0">
              <img
                v-if="storeLogo"
                :src="storeLogo"
                alt="Logo Footer"
                class="w-full h-full object-cover"
                @error="handleImageError"
              />
              <img
                v-else
                :src="DefaultPhotoImg"
                alt="Logo Placeholder"
                class="w-full h-full object-cover"
              />
            </div>
            <h3 class="text-base sm:text-xl font-bold text-text-secondary">
              {{ storeName }}
            </h3>
          </div>
          <p
            class="text-text-secondary text-xs sm:text-sm leading-relaxed mb-3 sm:mb-6"
          >
            برترین فروشگاه آنلاین با محصولات لوکس و باکیفیت. تجربه‌ای متفاوت از
            خرید آنلاین.
          </p>
          <div class="space-y-1 sm:space-y-2 text-xs sm:text-sm">
            <div class="flex items-center gap-1 sm:gap-2 text-text-primary">
              <MapPin class="w-3 h-3 sm:w-4 sm:h-4 text-landing-dark-bg" />
              <span>{{ contactInfo.address }}</span>
            </div>
            <div class="flex items-center gap-1 sm:gap-2 text-text-primary">
              <Phone class="w-3 h-3 sm:w-4 sm:h-4 text-landing-dark-bg" />
              <span>{{ contactInfo.phone }}</span>
            </div>
          </div>
        </div>

        <div class="grid grid-cols-2 md:col-span-2 gap-4 sm:gap-8">
          <div>
            <h3
              class="text-sm sm:text-lg font-semibold text-text-primary mb-2 sm:mb-4"
            >
              دسترسی سریع
            </h3>
            <ul class="space-y-1 sm:space-y-2 text-xs sm:text-sm">
              <li v-for="link in quickLinks" :key="link.to">
                <router-link
                  :to="link.to"
                  class="text-text-secondary hover:text-primary transition flex items-center gap-1 sm:gap-2 group"
                >
                  <component
                    :is="link.icon"
                    class="w-3 h-3 group-hover:text-primary transition-colors"
                  />
                  {{ link.text }}
                </router-link>
              </li>
            </ul>
          </div>

          <div>
            <h3
              class="text-sm sm:text-lg font-semibold text-text-primary mb-2 sm:mb-4"
            >
              خدمات مشتریان
            </h3>
            <ul class="space-y-1 sm:space-y-2 text-xs sm:text-sm">
              <li v-for="link in serviceLinks" :key="link.to">
                <router-link
                  :to="link.to"
                  class="text-text-secondary hover:text-primary transition flex items-center gap-1 sm:gap-2 group"
                >
                  <component
                    :is="link.icon"
                    class="w-3 h-3 group-hover:text-primary transition-colors"
                  />
                  {{ link.text }}
                </router-link>
              </li>
            </ul>
          </div>
        </div>

        <div class="md:col-span-1">
          <h3
            class="text-sm sm:text-lg font-semibold text-text-primary mb-2 sm:mb-4"
          >
            نماد اعتماد
          </h3>
          <div v-if="enamadHtml" class="flex justify-start">
            <div class="w-[40%] sm:w-[50%]" v-html="enamadHtml"></div>
          </div>
        </div>
      </div>

      <div
        class="border-t border-border mt-6 sm:mt-12 pt-4 sm:pt-8 text-center text-text-secondary text-xs sm:text-sm flex flex-col md:flex-row justify-between items-center gap-2 sm:gap-4"
      >
        <p>
          &copy; {{ new Date().getFullYear() }} {{ storeName }} تمامی حقوق محفوظ
          است.
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { ref, onMounted } from "vue";
import {
  MapPin,
  Phone,
  MessageCircle,
  User,
  Settings,
  HelpCircle,
  BookOpen,
  Package,
} from "lucide-vue-next";
import ShopService from "@/api/services/shopService";
import DefaultPhotoImg from "@/assets/Defaultphoto.png";

const storeName = ref("طلایی‌شاپ");
const storeLogo = ref(null);
const contactInfo = ref({
  phone: "",
  address: "",
});

const enamadHtml = ref(null);

const quickLinks = [
  { to: "/AboutUs", text: "درباره ما", icon: User },
  { to: "/contact", text: "تماس با ما", icon: MessageCircle },
  { to: "/faq", text: "سوالات متداول", icon: HelpCircle },
  { to: "/profile", text: "حساب کاربری", icon: Settings },
  { to: "/blog", text: "مجله آموزشی", icon: BookOpen },
];

const serviceLinks = [{ to: "/products", text: "لیست محصولات", icon: Package }];

const fetchStoreData = async () => {
  try {
    // دریافت اطلاعات کلی فروشگاه
    const storeData = await ShopService.getStore();

    if (storeData) {
      storeName.value = storeData.name || storeData.store_name || storeName.value;
      storeLogo.value = storeData.logo || storeData.image || storeData.store_logo || null;
      
      // اگه توی همون getStore آدرس اومد ازش استفاده کن
      if (storeData.address) {
        contactInfo.value.address = storeData.address;
      }
      
      // ترکیب province و city برای ساختن آدرس
      if (!storeData.address && (storeData.province || storeData.city)) {
        const addressParts = [storeData.province, storeData.city].filter(Boolean);
        if (addressParts.length > 0) {
          contactInfo.value.address = addressParts.join('، ');
        }
      }
    }

    // دریافت اطلاعات تماس شامل شماره تلفن و آدرس
    const contactData = await ShopService.getStoreContact();

    if (contactData) {
      contactInfo.value = {
        phone: contactData.phone || "-------",
        address: contactData.address || contactInfo.value.address || "-------",
      };
    }

    // دریافت لایسنس‌ها (نماد اعتماد)
    if (storeData?.licenses_link?.enamad) {
      enamadHtml.value = storeData.licenses_link.enamad;
    }
  } catch (error) {
    console.error("Error fetching store data:", error);
  }
};

const handleImageError = (e) => {
  e.target.src = DefaultPhotoImg;
  storeLogo.value = null;
};

onMounted(() => {
  fetchStoreData();
});
</script>

<style scoped>
.container-custom {
  max-width: 100%;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

@media screen and (min-width: 640px) {
  .container-custom {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

@media screen and (min-width: 1024px) {
  .container-custom {
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }
}
</style>